import React from 'react'

import { FormatedPatientFormData } from './_props'
import FormField from '../../Common/form/formField/FormField'
import { FormFieldProps } from '../../Common/form/formField/_props'
import { useFormContextPatient } from './_utils'

const PatientFormField = <T,>(props: FormFieldProps<FormatedPatientFormData, T>) => {
    const { name } = props
    const { resetField } = useFormContextPatient()
    const handleClear = () => {
        if (name) {
            resetField(name, {
                defaultValue: '',
                keepDirty: true,
                keepError: false,
                keepTouched: true,
            })
        }
    }
    return <FormField {...props} onClear={handleClear} />
}

export default PatientFormField
